import { useEffect } from 'react';

import { useSocket } from '../contexts/SocketContext';

export function useTicketSocket(ticketId: string | undefined) {
  const { socket } = useSocket();

  useEffect(() => {
    if (!socket || !ticketId) return;

    socket.emit('join:ticket', ticketId, (err) => {
      if (err) console.error('Socket join error:', err);
    });

    return () => {
      socket.emit('leave:ticket', ticketId);
    };
  }, [socket, ticketId]);

  return socket;
}
